//==========================================================================================================
// Copyright (C) Nore Technology AB. All Rights Reserved.
//==========================================================================================================

//-------------------------------------------------------------------------------------
// Imports
//-------------------------------------------------------------------------------------

import { createUseStyles } from "react-jss";
import { ConsilioBaseTheme } from "~base/Styling/ConsilioTheme";

//-------------------------------------------------------------------------------------
// Styling
//-------------------------------------------------------------------------------------

export const useStyles = createUseStyles((_theme: ConsilioBaseTheme) => ({
    codeBlock: {
        fontFamily: "monospace",
        background: "#f0f0f0",
        padding: "1em",
        wordBreak: "break-all",
        borderRadius: "4px",
        margin: 0,
        marginBottom: 16,
        width: "100%",
        boxSizing: "border-box",
        whiteSpace: "pre-wrap",
    },
}));
